import { Identity, IsNumber, IsString } from "@pdfking/tfunc"

import { is_function } from "./is_function"
import { is_null } from "./is_null"
import { map } from "./map"

export const getter = e => {
  if (IsString(e) || IsNumber(e)) {
    return o => o[e]
  } else if (is_null(e)) {
    return Identity
  } else if (is_function(e)) {
    return e
  } else {
    return o => map(v => getter(v)(o), e)
  }
}
